import { Box, Flex, Image, Text } from "@chakra-ui/react";
import useMediaQ from "@root/hooks/useMediaQ";
import React from "react";
import { Outlet } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { AlertWrapper } from "@root/components";

const AuthLayout: React.FC = () => {
  const { t } = useTranslation("common");
  const { lg_1060 } = useMediaQ();
  return (
    <AlertWrapper>
      <div>
        <Flex
          flexDirection={{ base: "column", md: "row" }}
          w="100%"
          h={{ base: "100vh", md: "99vh" }}
          overflowY="hidden"
        >
          <Flex
            minH={"100vh"}
            alignItems={"center"}
            overflowY={"auto"}
            position="relative"
            justifyContent={"center"}
            flex={1}
          >
            <Outlet />
          </Flex>
        </Flex>
        {/* Bottom */}
        {/* <Box
          bottom={{ base: "0", md: "0" }}
          width="100%"
          mt={{ base: "auto", md: "0" }}
        >
          <CommonFooter />
        </Box> */}
      </div>
    </AlertWrapper>
  );
};

export default AuthLayout;
